/**
 * Shared font zoom (+/−) for Editor.js actbar and offcanvas detail text.
 * Limits map editorial 9–24 pt to 12–32 px at 96dpi (REDMINE-2261).
 */

export const MIN_FONT_SIZE = 12;
export const MAX_FONT_SIZE = 32;
export const FONT_SIZE_STEP = 2;
export const STORAGE_KEY = 'naxos-fontsize';

/**
 * @param {*} value
 * @returns {number}
 */
export function clampFontSize(value) {
	const n = Number(value);
	if (!Number.isFinite(n)) {
		return MIN_FONT_SIZE;
	}

	return Math.min(MAX_FONT_SIZE, Math.max(MIN_FONT_SIZE, n));
}

/**
 * @returns {number|null}
 */
export function readStoredFontSize() {
	const raw = localStorage.getItem(STORAGE_KEY);
	if (raw === null || raw === '') {
		return null;
	}

	const n = Number(raw);
	if (!Number.isFinite(n)) {
		return null;
	}

	return clampFontSize(n);
}

/**
 * @param {JQuery} $el
 * @returns {number|null}
 */
export function parseFontSizeFromElement($el) {
	if (!$el?.length) {
		return null;
	}

	const n = parseFloat($el.css('font-size'));

	return Number.isFinite(n) ? n : null;
}

/**
 * @param {JQuery} $targets
 * @param {number} size
 * @returns {number}
 */
export function applyFontSize($targets, size) {
	const clamped = clampFontSize(size);
	$targets.css('font-size', `${clamped}px`);
	localStorage.setItem(STORAGE_KEY, String(clamped));

	return clamped;
}

/**
 * @param {JQuery} $scope
 * @param {number} size
 * @returns {void}
 */
export function syncZoomButtons($scope, size) {
	const clamped = clampFontSize(size);
	const $buttons = $scope.find('[data-actbar="zoom"]');
	$buttons.filter('[data-actype="plus"]').prop('disabled', clamped >= MAX_FONT_SIZE);
	$buttons.filter('[data-actype="minus"]').prop('disabled', clamped <= MIN_FONT_SIZE);
}

/**
 * @param {JQuery} $targets
 * @param {'plus'|'minus'|string} direction
 * @param {JQuery} $buttonScope
 * @returns {number}
 */
export function adjustFontSize($targets, direction, $buttonScope) {
	const current = parseFontSizeFromElement($targets.first()) ?? readStoredFontSize() ?? 16;
	const next = clampFontSize(current + (direction === 'minus' ? -FONT_SIZE_STEP : FONT_SIZE_STEP));
	applyFontSize($targets, next);
	syncZoomButtons($buttonScope, next);

	return next;
}
